import { XStack } from '@/components/ui/layout/layout';

import { McpInfoFilterDropdown } from './mcp-info-filter-dropdown';

import type { McpCallFilters, McpUsageSummary } from '../mcp-info.types';

const WINDOW_OPTIONS = [
  { hours: 24, label: 'Last 24h' },
  { hours: 24 * 7, label: 'Last 7d' },
  { hours: 24 * 30, label: 'Last 30d' },
];

interface McpInfoToolbarProps {
  filters: McpCallFilters;
  summary: McpUsageSummary | undefined;
  callCount: number;
  onChange: (filters: Partial<McpCallFilters>) => void;
}

function countOptions(counts: Record<string, number> | undefined) {
  return Object.entries(counts ?? {}).map(([value, count]) => ({
    value,
    label: value,
    count,
  }));
}

export function McpInfoToolbar({
  filters,
  summary,
  callCount,
  onChange,
}: McpInfoToolbarProps) {
  return (
    <XStack className="items-center gap-2 px-3 py-2 border-b border-border shrink-0 flex-wrap">
      <McpInfoFilterDropdown
        title="Time window"
        selectedValue={String(filters.sinceHours)}
        allLabel="Time window"
        options={WINDOW_OPTIONS.map((option) => ({
          value: String(option.hours),
          label: option.label,
        }))}
        onSelect={(value) =>
          onChange({ sinceHours: Number(value) || WINDOW_OPTIONS[0].hours })
        }
      />

      <McpInfoFilterDropdown
        title="Filter by client"
        selectedValue={filters.clientName}
        allLabel="All clients"
        options={countOptions(summary?.by_client_name)}
        onSelect={(clientName) => onChange({ clientName })}
      />

      <McpInfoFilterDropdown
        title="Filter by tool"
        selectedValue={filters.toolName}
        allLabel="All tools"
        options={countOptions(summary?.by_tool_name)}
        onSelect={(toolName) => onChange({ toolName })}
      />

      <span className="ml-auto text-xs text-foreground-muted tabular-nums">
        {callCount} calls
      </span>
    </XStack>
  );
}
